// src/services/clubEntryService.ts

import { EntryModel } from "../models";
import { ENTRIES_PER_PAGE , API_BASE_URL } from "../constants";
import apiClient from "./apiClient";
import { mapRawEntry as mapEntry } from "./entryMapper";


export interface ClubEntryResponse {
  entries: EntryModel[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
}

export const fetchEntriesByClubId = async (
  clubId: number,
  page: number = 1,
  pageSize: number = ENTRIES_PER_PAGE,
  showRookieEntries: boolean = true,
  sort: string = "newest",
  filterToday: boolean = false,
  rookieOnly: boolean = false,
  keyword: string = ""
): Promise<ClubEntryResponse> => {
  const params = new URLSearchParams({
    page:              String(page - 1),
    size:              String(pageSize),
    showRookieEntries: String(showRookieEntries),
    sort,
    filterToday:       String(filterToday),
    rookieOnly:        String(rookieOnly),
  });

  // Keyword is optional and omitted when empty
  if (keyword && keyword.trim()) {
    params.append("keyword", keyword.trim());
  }

  const token = localStorage.getItem("token");
  const headers: HeadersInit = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}/api/entries/clubId/${clubId}?${params}`, { headers });
  if (!res.ok) throw new Error("Kulüp tanımları yüklenemedi.");

  const json = await res.json();
  const entries = (json.content ?? []).map(mapEntry);
  return {
    entries,
    currentPage:  page,
    totalPages:   json.totalPages ?? 1,
    totalItems:   json.totalItems ?? json.totalElements ?? entries.length,
  };
};

export const fetchEntriesByTeamId = async (
  teamId: number,
  page: number = 1,
  pageSize: number = ENTRIES_PER_PAGE,
  showRookieEntries: boolean = true,
  sort: string = "newest",
  filterToday: boolean = false,
  rookieOnly: boolean = false,
  keyword: string = ""
): Promise<ClubEntryResponse> => {
  const params = new URLSearchParams({
    page:              String(page - 1),
    size:              String(pageSize),
    showRookieEntries: String(showRookieEntries),
    sort,
    filterToday:       String(filterToday),
    rookieOnly:        String(rookieOnly),
  });

  // Keyword is optional and omitted when empty
  if (keyword && keyword.trim()) {
    params.append("keyword", keyword.trim());
  }

  const token = localStorage.getItem("token");
  const headers: HeadersInit = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}/api/entries/teamId/${teamId}?${params}`, { headers });
  if (!res.ok) throw new Error("Takım tanımları yüklenemedi.");

  const json = await res.json();
  const entries = (json.content ?? []).map(mapEntry);
  return {
    entries,
    currentPage:  page,
    totalPages:   json.totalPages ?? 1,
    totalItems:   json.totalItems ?? json.totalElements ?? entries.length,
  };
};

export const postClubEntry = async (content: string, clubId: number): Promise<EntryModel> => {
  const raw = await apiClient.post<any>("/api/entries", { content, clubId });
  return mapEntry(raw);
};

export const postTeamEntry = async (content: string, teamId: number): Promise<EntryModel> => {
  const raw = await apiClient.post<any>("/api/entries", { content, teamId });
  return mapEntry(raw);
};